export default "/images/About_header.png?31d50cc2a003cbe4d484f60123271d56";